import ActivityComments64 from "./64/ActivityComments";
import ActivityEgg64 from "./64/ActivityEgg";
import ActivityResource64 from "./64/ActivityResource";
import ActivityText64 from "./64/ActivityText";
import ActivityTweet64 from "./64/ActivityTweet";
import Annotate24 from "./24/Annotate";
import Annotate32 from "./32/Annotate";
import AnnotationGroup24 from "./24/AnnotationGroup";
import AnnotationGroupAlt24 from "./24/AnnotationGroupAlt";
import Archive24 from "./24/Archive";
import Arrow24 from "./24/Arrow";
import ArrowDown16 from "./16/ArrowDown";
import ArrowDown24 from "./24/ArrowDown";
import ArrowDown32 from "./32/ArrowDown";
import ArrowLeft16 from "./16/ArrowLeft";
import ArrowLeft32 from "./32/ArrowLeft";
import ArrowLongLeft16 from "./16/ArrowLongLeft";
import ArrowLongRight16 from "./16/ArrowLongRight";
import ArrowRight16 from "./16/ArrowRight";
import ArrowRight24 from "./24/ArrowRight";
import ArrowRight32 from "./32/ArrowRight";
import ArrowUp16 from "./16/ArrowUp";
import ArrowUp32 from "./32/ArrowUp";
import Avatar16 from "./16/Avatar";
import Avatar24 from "./24/Avatar";
import Avatar64 from "./64/Avatar";
import BEActivity64 from "./64/BEActivity";
import BEAnalytics64 from "./64/BEAnalytics";
import BECollectionManual64 from "./64/BECollectionManual";
import BECollectionSmart64 from "./64/BECollectionSmart";
import BELibrary64 from "./64/BELibrary";
import BENews64 from "./64/BENews";
import BEProject64 from "./64/BEProject";
import BEResourcesBox64 from "./64/BEResourcesBox";
import BEResourcesBoxes64 from "./64/BEResourcesBoxes";
import Bookmark24 from "./24/Bookmark";
import Bookmark32 from "./32/Bookmark";
import Calendar24 from "./24/Calendar";
import Checkmark16 from "./16/Checkmark";
import CircleArrowDown64 from "./64/CircleArrowDown";
import CircleArrowLeft64 from "./64/CircleArrowLeft";
import CircleArrowRight64 from "./64/CircleArrowRight";
import CircleArrowUp64 from "./64/CircleArrowUp";
import CircleMinus24 from "./24/CircleMinus";
import CircleMinus32 from "./32/CircleMinus";
import CirclePlus24 from "./24/CirclePlus";
import CirclePlus32 from "./32/CirclePlus";
import Close16 from "./16/Close";
import Close24 from "./24/Close";
import Close32 from "./32/Close";
import Comment24 from "./24/Comment";
import Comment32 from "./32/Comment";
import CommentPencil32 from "./32/CommentPencil";
import CommentPost32 from "./32/CommentPost";
import Copy24 from "./24/Copy";
import Delete24 from "./24/Delete";
import Delete32 from "./32/Delete";
import DisclosureDown16 from "./16/DisclosureDown";
import DisclosureDown24 from "./24/DisclosureDown";
import DisclosureDown32 from "./32/DisclosureDown";
import DisclosureUp16 from "./16/DisclosureUp";
import DisclosureUp24 from "./24/DisclosureUp";
import DisclosureUp32 from "./32/DisclosureUp";
import Download24 from "./24/Download";
import Duplicate24 from "./24/Duplicate";
import Duplicate32 from "./32/Duplicate";
import EditProfile24 from "./24/EditProfile";
import Export24 from "./24/Export";
import EyeClosed32 from "./32/EyeClosed";
import EyeOpen16 from "./16/EyeOpen";
import EyeOpen32 from "./32/EyeOpen";
import Eyeball24 from "./24/Eyeball";
import FeatureExplore32 from "./32/FeatureExplore";
import FeatureMeasure32 from "./32/FeatureMeasure";
import Following64 from "./64/Following";
import Glasses64 from "./64/Glasses";
import Globe64 from "./64/Globe";
import Grabber32 from "./32/Grabber";
import GrabberInactive32 from "./32/GrabberInactive";
import Info16 from "./16/Info";
import InteractComment16 from "./16/InteractComment";
import InteractAnnotate24 from "./24/InteractAnnotate";
import InteractHighlight24 from "./24/InteractHighlight";
import InteractComment24 from "./24/InteractComment";
import InteractAnnotate32 from "./32/InteractAnnotate";
import InteractHighlight32 from "./32/InteractHighlight";
import InteractComment32 from "./32/InteractComment";
import Key32 from "./32/Key";
import Journals64 from "./64/Journals";
import Lamp64 from "./64/Lamp";
import LanguageGlobe24 from "./24/LanguageGlobe";
import Lightning24 from "./24/Lightning";
import Link24 from "./24/Link";
import Lock16 from "./16/Lock";
import Lock32 from "./32/Lock";
import Logout24 from "./24/Logout";
import Mail24 from "./24/Mail";
import Mail32 from "./32/Mail";
import ManifoldLogo32 from "./32/ManifoldLogo";
import Menu32 from "./32/Menu";
import Metadata64 from "./64/Metadata";
import Minus24 from "./24/Minus";
import Mug64 from "./64/Mug";
import New64 from "./64/New";
import Notes24 from "./24/Notes";
import Notifications24 from "./24/Notifications";
import PauseSolid24 from "./24/PauseSolid";
import Play16 from "./16/Play";
import PlaySolid24 from "./24/PlaySolid";
import PlayOutline24 from "./24/PlayOutline";
import Plus16 from "./16/Plus";
import Plus24 from "./24/Plus";
import Privacy24 from "./24/Privacy";
import ProjectCollections64 from "./64/ProjectCollections";
import Projects64 from "./64/Projects";
import ReadingGroup24 from "./24/ReadingGroup";
import RecentActivity64 from "./64/RecentActivity";
import Reload24 from "./24/Reload";
import Reload32 from "./32/Reload";
import Reply16 from "./16/Reply";
import Resource24 from "./24/Resource";
import ResourceAudio64 from "./64/ResourceAudio";
import ResourceCollection64 from "./64/ResourceCollection";
import ResourceDocument64 from "./64/ResourceDocument";
import ResourceFile64 from "./64/ResourceFile";
import ResourceFilled16 from "./16/ResourceFilled";
import ResourceFilled24 from "./24/ResourceFilled";
import ResourceImage64 from "./64/ResourceImage";
import ResourceInteractive64 from "./64/ResourceInteractive";
import ResourceLink64 from "./64/ResourceLink";
import ResourcePdf64 from "./64/ResourcePdf";
import ResourcePresentation64 from "./64/ResourcePresentation";
import ResourceSpreadsheet64 from "./64/ResourceSpreadsheet";
import ResourceVideo64 from "./64/ResourceVideo";
import Resources64 from "./64/Resources";
import Search16 from "./16/Search";
import Search24 from "./24/Search";
import Search32 from "./32/Search";
import Settings32 from "./32/Settings";
import Share24 from "./24/Share";
import Share32 from "./32/Share";
import SocialCite32 from "./32/SocialCite";
import SocialEmail32 from "./32/SocialEmail";
import SocialFacebook32 from "./32/SocialFacebook";
import SocialGithub32 from "./32/SocialGithub";
import SocialGoogle32 from "./32/SocialGoogle";
import SocialInstagram32 from "./32/SocialInstagram";
import SocialLinkedIn32 from "./32/SocialLinkedIn";
import SocialSlack32 from "./32/SocialSlack";
import SocialTwitter32 from "./32/SocialTwitter";
import Speaker24 from "./24/Speaker";
import SpeakerMuted24 from "./24/SpeakerMuted";
import StarSquircle32 from "./32/StarSquircle";
import StarSquircleFilled32 from "./32/StarSquircleFilled";
import Star24 from "./24/Star";
import StopSign64 from "./64/StopSign";
import Text24 from "./24/Text";
import TextsBook64 from "./64/TextsBook";
import TextsLoosePages64 from "./64/TextsLoosePages";
import TextsStacked64 from "./64/TextsStacked";
import TimerClock32 from "./32/TimerClock";
import Toc64 from "./64/Toc";
import Touch64 from "./64/Touch";
import Upload32 from "./32/Upload";
import Upload64 from "./64/Upload";
import Users32 from "./32/Users";
import WarningSign64 from "./64/WarningSign";
import ZoomIn16 from "./16/ZoomIn";
import ZoomOut16 from "./16/ZoomOut";
import Bold24 from "./24/Bold";
import Italic24 from "./24/Italic";
import Underline24 from "./24/Underline";
import UnorderedList24 from "./24/UnorderedList";
import OrderedList24 from "./24/OrderedList";
import BlockQuote24 from "./24/BlockQuote";
import Code24 from "./24/Code";
import Strikethrough24 from "./24/Strikethrough";
import EditorRTE24 from "./24/EditorRTE";
import EditorHTML24 from "./24/EditorHTML";
import DarkMode16 from "./16/DarkMode";
import LightMode16 from "./16/LightMode";
import Undo24 from "./24/Undo";
import Redo24 from "./24/Redo";
import Iframe24 from "./24/Iframe";
import RTELink24 from "./24/RTELink";
import RTEImage24 from "./24/RTEImage";
import CodeBlock24 from "./24/CodeBlock";
import ProjectCollection32 from "./32/ProjectCollection";

export default {
  ActivityComments64,
  ActivityEgg64,
  ActivityResource64,
  ActivityText64,
  ActivityTweet64,
  Annotate24,
  Annotate32,
  AnnotationGroup24,
  AnnotationGroupAlt24,
  Archive24,
  Arrow24,
  ArrowDown16,
  ArrowDown24,
  ArrowDown32,
  ArrowLeft16,
  ArrowLeft32,
  ArrowLongLeft16,
  ArrowLongRight16,
  ArrowRight16,
  ArrowRight24,
  ArrowRight32,
  ArrowUp16,
  ArrowUp32,
  Avatar16,
  Avatar24,
  Avatar64,
  BEActivity64,
  BEAnalytics64,
  BECollectionManual64,
  BECollectionSmart64,
  BELibrary64,
  BENews64,
  BEProject64,
  BEResourcesBox64,
  BEResourcesBoxes64,
  BlockQuote24,
  Bold24,
  Bookmark24,
  Bookmark32,
  Calendar24,
  Checkmark16,
  CircleArrowDown64,
  CircleArrowLeft64,
  CircleArrowRight64,
  CircleArrowUp64,
  CircleMinus24,
  CircleMinus32,
  CirclePlus24,
  CirclePlus32,
  Close16,
  Close24,
  Close32,
  Code24,
  CodeBlock24,
  Comment24,
  Comment32,
  CommentPencil32,
  CommentPost32,
  Copy24,
  DarkMode16,
  Delete24,
  Delete32,
  DisclosureDown16,
  DisclosureDown24,
  DisclosureDown32,
  DisclosureUp16,
  DisclosureUp24,
  DisclosureUp32,
  Download24,
  Duplicate24,
  Duplicate32,
  EditProfile24,
  EditorHTML24,
  EditorRTE24,
  Export24,
  EyeClosed32,
  EyeOpen16,
  EyeOpen32,
  Eyeball24,
  FeatureExplore32,
  FeatureMeasure32,
  Following64,
  Glasses64,
  Globe64,
  Grabber32,
  GrabberInactive32,
  Iframe24,
  Info16,
  InteractComment16,
  InteractAnnotate24,
  InteractHighlight24,
  InteractComment24,
  InteractAnnotate32,
  InteractHighlight32,
  InteractComment32,
  Italic24,
  Journals64,
  Key32,
  Lamp64,
  LanguageGlobe24,
  LightMode16,
  Lightning24,
  Link24,
  Lock16,
  Lock32,
  Logout24,
  Mail24,
  Mail32,
  ManifoldLogo32,
  Menu32,
  Metadata64,
  Minus24,
  Mug64,
  New64,
  Notes24,
  Notifications24,
  OrderedList24,
  PauseSolid24,
  Play16,
  PlaySolid24,
  PlayOutline24,
  Plus16,
  Plus24,
  Privacy24,
  ProjectCollections64,
  ProjectCollection32,
  Projects64,
  ReadingGroup24,
  RecentActivity64,
  Redo24,
  Reload24,
  Reload32,
  Reply16,
  Resource24,
  ResourceAudio64,
  ResourceCollection64,
  ResourceDocument64,
  ResourceFile64,
  ResourceFilled16,
  ResourceFilled24,
  ResourceImage64,
  ResourceInteractive64,
  ResourceLink64,
  ResourcePdf64,
  ResourcePresentation64,
  ResourceSpreadsheet64,
  ResourceVideo64,
  Resources64,
  RTELink24,
  RTEImage24,
  Search16,
  Search24,
  Search32,
  Settings32,
  Share24,
  Share32,
  SocialCite32,
  SocialEmail32,
  SocialFacebook32,
  SocialGithub32,
  SocialGoogle32,
  SocialInstagram32,
  SocialLinkedIn32,
  SocialSlack32,
  SocialTwitter32,
  Speaker24,
  SpeakerMuted24,
  StarSquircle32,
  StarSquircleFilled32,
  Star24,
  StopSign64,
  Strikethrough24,
  Text24,
  TextsBook64,
  TextsLoosePages64,
  TextsStacked64,
  TimerClock32,
  Toc64,
  Touch64,
  Underline24,
  Undo24,
  UnorderedList24,
  Upload32,
  Upload64,
  Users32,
  WarningSign64,
  ZoomIn16,
  ZoomOut16
};
